import { combineReducers } from 'redux'

import controlReducer from './controlReducer'
import tokenReducer from './tokenReducer'

export default combineReducers({
	controlReducer,
	tokenReducer,
})